import { tv } from 'tailwind-variants'

export { default as SearchSidebar } from './SearchSidebar.vue'

export const searchSidebarVariants = tv({
  slots: {
    root: 'sticky top-16 self-start flex flex-col w-[278px] h-[calc(100vh-4rem)] bg-white',
    body: 'flex flex-1 flex-col items-center min-h-0 px-5 sm:px-0 py-[30px] gap-[30px] overflow-y-auto',
    title: 'text-2xl font-semibold text-primary text-center w-full sm:w-[210px] shrink-0',
    fields: 'flex flex-col items-stretch gap-5 w-full sm:w-[210px]',
    addCriteria: 'self-center shrink-0',
    footer: 'flex items-center justify-center gap-2.5 w-full py-[30px] shrink-0',
  },
})

export type SearchSidebarVariants = ReturnType<typeof searchSidebarVariants>
